export default __webpack_public_path__ + "images/0x51318b7d00db7acc4026c88c3952b66278b6a67f.png";